'use strict';

var React = require("react");
var RescriptReactRouter = require("@rescript/react/lib/js/src/RescriptReactRouter.js");

function Redirect(Props) {
  var url = Props.url;
  React.useEffect((function () {
          RescriptReactRouter.push(url);
          
        }), []);
  return React.createElement(React.Fragment, undefined);
}

function makeProps(prim0, prim1, prim2) {
  var tmp = {
    url: prim0
  };
  if (prim1 !== undefined) {
    tmp.key = prim1;
  }
  return tmp;
}

var make = Redirect;

exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
